<template>
  <v-container class="no-p" fluid>
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-btn icon to="/prealert-form">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>

    <h2 class="general-title-app mt-5 mb-2">{{ language.pre_alerts }}</h2>

    <div class="new-list-of-packages" v-if="items.length > 0">
      <v-list three-line>
        <template v-for="(item, index) in items">
          <template class="item-conteiner">
            <div class="pb-2">
              <v-list-item :key="index">
                <v-list-item-content>
                  <div class="new-list-of-packages__item-content">
                    <img
                      style="width:60px;height:6                           0px;"
                      src="@/assets/box-item.png"
                      :alt="item.contenidoarticulo"
                    />

                    <div class="new-list-of-packages__genearl-info">
                      <div class="detail__text" style="color:#929DB1;">
                        {{ item.fec_creacion }}
                      </div>
                      <div class="detail__text">
                        <b>Contenido </b> {{ item.contenidoarticulo }}
                      </div>
                      <div class="detail__text">
                        <b>{{ language.tracking_no }}:</b>
                        {{ item.tracking_number }}
                      </div>

                      <div class="detail__text">
                        <b>{{ language.supplier }} :</b>
                        {{ item.suplidor }}
                      </div>
                      <div class="detail__text">
                        <b>{{ language.cost }} :</b>
                        {{ item.valor_declarado }}
                      </div>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <div
                class="btn-status text-left px-2"
                v-if="parseInt(item.mostrar_boton) == 0"
              >
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  small
                  block
                  color="secondary"
                  class
                  @click="pickFile(item.trackingnumber, item.id_prealerta)"
                >
                  {{ language.upload_invoice }}

                  <!-- <v-icon right dark>cloud_upload</v-icon> -->
                </v-btn>
              </div>
            </div>
          </template>
        </template>
      </v-list>
    </div>

    <div v-else>
      <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">
          {{ language.you_have_no_data_available }}
        </div>
      </div>
      <v-progress-circular
        :size="90"
        color="blue"
        indeterminate
        class="loading-center"
        v-else
      ></v-progress-circular>
    </div>
    <div class="mainDrawerNav" v-if="drawer" absolute bottom temporary>
      <div>
        <v-btn icon @click="drawer = !drawer">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
      <div class="mainDrawerNav__user" to="/profile">
        <img src="@/assets/user_login.png" alt="logo" />

        <div class="user__content" v-if="profile.length > 0">
          <h2 class="user__name" v-if="profile[0].nombre != ''">
            Hola, {{ profile[0].nombre }}
          </h2>
          <p class="user__local" v-if="profile[0].descripcion_oficina != ''">
            {{ profile[0].descripcion_oficina }}
          </p>
        </div>
      </div>
      <div class="mb-2 mt-2">
        <v-btn
          :loading="loading"
          :disabled="loading"
          large
          block
          color="secondary"
          class
          @click="logOut"
        >
          Cerrar Sección
        </v-btn>
      </div>

      <v-list nav dense>
        <v-list-item-group v-model="group">
          <v-list-item to="/home">
            <v-list-item-title><img src="" alt="" />Paquetes</v-list-item-title>
          </v-list-item>

          <v-list-item to="/prealert">
            <v-list-item-title
              ><img src="" alt="" />Pre-alerta</v-list-item-title
            >
          </v-list-item>

          <v-list-item to="/office">
            <v-list-item-title
              ><img src="" alt="" />Sucursales</v-list-item-title
            >
          </v-list-item>

          <v-list-item to="/help">
            <v-list-item-title><img src="" alt="" />Ayuda</v-list-item-title>
          </v-list-item>

          <v-list-item to="/profile">
            <v-list-item-title><img src="" alt="" />Perfil</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </v-container>
</template>

<script>
// import Helpers from '../utils/helpers'
import Server from "../utils/server";
var files = [];
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      // (newValue, oldValue) => {
      (newValue) => {
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
          }
        }
      }
    );
  },
  mounted() {
    if (this.currentUser != undefined) {
      this.getPacks();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
    }
  },
  data() {
    return {
      clipped: false,
      items: [],
      currentUser: undefined,
      noData: false,
      loading: false,
      guia: null,
      idpack: null,
      drawer: false,
      group: null,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    login() {
      return this.$store.getters.login;
    },
    language: function() {
      return this.$store.getters.language;
    },
    profile: function() {
      return this.$store.getters.profile;
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch("logout");
      window.MobileApi.signOut();

      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.logout, formData).then(
        // response => {},
        () => {},
        () => {}
      );
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      console.log(this.currentUser);
      this.$http.post(Server.prealertas, formData).then(
        (response) => {
          console.log(response.body);
          if (response.body.resultado !== "NO") {
            this.items = response.body;
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = this.language.an_error_has_occurred_try_again_later;
        }
      );
    },
    pickFile(guia, idpack) {
      window.MobileApi.uploadInvoice(
        Server.uploadInvoicePrealerta,
        guia,
        idpack,
        this.currentUser.userName,
        this.getPacks
      );
    },
    onFilePicked() {
      this.loading = true;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageFile = files[0]; // this is an image file that can be sent to server...
          var formData = new FormData();
          formData.append("text1", this.currentUser.userName);
          formData.append("text3", this.currentUser.pushId);
          formData.append("device", window.MobileApi.device);
          formData.append("PARAMETRO2", this.guia);
          formData.append("PARAMETRO1", this.idpack);
          formData.append("photo", this.imageFile);
          this.$http.post(Server.uploadInvoice, formData).then(
            // response => {
            () => {
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        });
      }
    },
  },
  name: "App",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
